"use client";

import { Typography } from "@/components/ui/typography";
import { useTranslations } from "next-intl";

export type StatusReferenceIdsProps = {
  orderId?: string;
};

export function StatusReferenceIds({ orderId }: StatusReferenceIdsProps) {
  const t = useTranslations("Checkout");

  if (!orderId) {
    return null;
  }

  return (
    <div
      data-testid="status-reference-ids"
      className="mx-auto flex flex-col gap-1 text-center text-sm text-primary-70"
    >
      <div>
        <Typography variant="eyebrow" className="text-sm">
          {t("orderSection.order")}:
        </Typography>{" "}
        {orderId}
      </div>
    </div>
  );
}
